import { useTheme } from '@emotion/react';
import { Typography, Box } from '@mui/material';
import { BASE_HOST, BASE_URI } from '../globals';
import { useFetchGet } from '../hooks';

function AvailableDomainsPage() {
    const { data: regions } = useFetchGet(`${BASE_URI}/region/`, []);
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: 3
            }}>
            <Box sx={{ mb: 3, p: 2 }}>
                <Typography variant="h1" color="primary" gutterBottom>
                    Beschikbare domeinen
                </Typography>
                <Typography variant="h2" color="secondary" gutterBottom>
                    Hieronder volgt de lijst met regio&apos;s die beschikbaar zijn voor
                    OpenVerkiezingen.
                </Typography>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    mt: 3,
                    my: 'auto',
                    alignContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                {regions?.map(({ slug, name }) => (
                    <Box
                        key={slug}
                        sx={{
                            p: 3,
                            display: 'flex',
                            alignItems: 'center',
                            maxWidth: 'sm',
                            width: '100%',
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 1,
                            mb: 2,
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word'
                        }}>
                        <img
                            alt={name}
                            src={`/regionLogos/${slug}.svg`}
                            style={{ width: '15%', aspectRatio: 'auto' }}
                        />
                        <Box sx={{ ml: 3, textAlign: 'left' }}>
                            <Typography variant="h6" color="primary">
                                {name}
                            </Typography>
                            <Typography
                                variant="body1"
                                component="p"
                                sx={{ wordBreak: 'break-word' }}>
                                <a
                                    href={`${window.location.protocol}//${slug}.${BASE_HOST}`}
                                    style={{
                                        color: theme.palette.secondary.main,
                                        textDecoration: 'none'
                                    }}>
                                    {`${window.location.protocol}//${slug}.${BASE_HOST}`}
                                </a>
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default AvailableDomainsPage;
